import { render } from "./ExportDetails.vue?vue&type=template&id=4f865277&scoped=true"
import script from "./ExportDetails.vue?vue&type=script&lang=js"
export * from "./ExportDetails.vue?vue&type=script&lang=js"

import "./ExportDetails.vue?vue&type=style&index=0&id=4f865277&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f865277"]])

export default __exports__